var _circle, _ellipse, _ellipse2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1111,
    cy: 9.80158,
    r: 9.409,
    fill: "url(#paint0_radial_2063_57434)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2406,
    cy: 4.1642,
    rx: 6.31834,
    ry: 3.72922,
    transform: "rotate(1.31904 10.2406 4.1642)",
    fill: "url(#paint1_linear_2063_57434)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.48547,
    cy: 2.53281,
    rx: 1.85573,
    ry: 0.883081,
    transform: "rotate(-21.8222 7.48547 2.53281)",
    fill: "url(#paint2_radial_2063_57434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2063_57434",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1111 9.80158) rotate(90) scale(9.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15BEF3",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2063_57434",
    x1: 10.2406,
    y1: 0.434984,
    x2: 10.2406,
    y2: 7.89342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BEF3",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2063_57434",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.48547 2.53281) rotate(90) scale(0.883081 1.85573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.8edf9f89da5a6c05842e16b4dd8dc42d.svg";
export { ForwardRef as ReactComponent };